import { ListViewProvider, useListView } from './core/ListViewProvider'
import { QueryRequestProvider, useQueryRequest } from './core/QueryRequestProvider'
import { QueryResponseProvider, useQueryResponse } from './core/QueryResponseProvider'
import { Header } from '../../../../../_component/table/Header'
import { deleteApplication } from './core/_requests'
import { ApplicationSidebar } from './ApplicationSidebar'
import { ApplicationDetails } from './ApplicationDetails'
import {useMemo} from 'react'
import {useQuery} from '@tanstack/react-query'
import {QUERIES, stringifyRequestQuery} from '../../../../../_metronic/helpers'
import {v2_get_request_api} from '../../../../../api/get'
import {Job} from '../../job/jobs-list/core/_models'

const List = () => {
  const {
    selected,
    clearSelected,
  } = useListView()
  const { refetch, isLoading } = useQueryResponse()
  const { updateState } = useQueryRequest()

  const jobsQuery = useMemo(
    () =>
      stringifyRequestQuery({
        page_number: 1,
        page_size: 200,
        sort_field: 'title',
        sort_order: 'asc',
      } as any),
    []
  )

  const {data: jobsResponse} = useQuery([QUERIES.JOB_LIST, jobsQuery], v2_get_request_api)

  const jobOptions = useMemo(() => {
    const entities: Job[] = jobsResponse?.data?.entities || jobsResponse?.entities || []
    return (entities || [])
      .filter((j) => j?.id && j?.title)
      .map((j) => ({value: String(j.id), label: String(j.title).trim()}))
  }, [jobsResponse])

  return (
    <div className='flex flex-col gap-6 h-[calc(100vh-120px)]'>
      <Header
        updateState={updateState}
        isLoading={isLoading}
        refetch={refetch}
        selected={selected}
        clearSelected={clearSelected}
        deleteAction={deleteApplication}
        filterMode='instant'
        fields={[{name: 'job_id', label: 'Job Title', type: 'select', options: jobOptions, searchable: true}]}
        title='Application'
        createAble={false}
        searchAble={true}
        searchFields={['full_name', 'email', 'phone']}
      />

      <div className='flex flex-1 min-h-0 overflow-hidden border-t border-gray-200'>
        {/* Left Sidebar - Application List */}
        <div className='w-full lg:w-1/3 xl:w-1/4 bg-white border-r border-gray-200 flex flex-col'>
          <ApplicationSidebar />
        </div>

        {/* Right Pane - Application Details */}
        <div className='hidden lg:block flex-1 bg-white'>
          <ApplicationDetails />
        </div>
      </div>
    </div>
  )
}

export const ApplicationsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <List />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
